// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","listTab":"y5_7Ss0zfWaCO3wz","listText":"hc1kKc79YlA2UjJW","listIcon":"uSTdqjwbRhterUg7"};